export interface SidebarConfig {
  width: number
  collapsedWidth: number
  showLogo: boolean
  showSearch: boolean
  backgroundColor: string
  textColor: string
  activeTextColor: string
  hoverColor: string
  menuHoverBackground: string
  collapseTransition: boolean
  uniqueOpened: boolean
  scrollbarWidth?: number
  emptyText: string
  defaultOpeneds: string[]
}

export const sidebarConfig: SidebarConfig = {
  width: 200,
  collapsedWidth: 64,
  showLogo: false,
  showSearch: false,
  backgroundColor: '#fefefe',
  textColor: '#304156',
  activeTextColor: '#008dbc',
  hoverColor: '#fff',
  menuHoverBackground: 'rgba(0,141,188,.6)',
  collapseTransition: true,
  uniqueOpened: true,
  scrollbarWidth: 4,
  emptyText: '暂无菜单权限',
  defaultOpeneds: ['/dashboard']
}
